import { SpanTree } from "../structure/span/span-tree";
import { EntityMention } from "../model/entities";
import { SituationMention, MentionArgument } from '../model/situations';

export function returnEntityMentionList(
	spanToTypeMap: Map<string, string>,
	spanTreeMap: Map<string, SpanTree>
): EntityMention[] {
    const mentionMap = new Map<string, EntityMention>();

	spanTreeMap.forEach((tokenization) => {
		tokenization.nodes.forEach((node) => {
			if (node.kind === "span" && node.mentionModel === "entity") {
                if(spanToTypeMap.has(node.spanId.uuidString)){

                    if(mentionMap.has(node.spanId.uuidString)){
                        const updateMention = mentionMap.get(
                            node.spanId.uuidString
                        );

                        if (updateMention !== undefined) {
                            updateMention?.tokens.tokenIndexList.push(
                                ...node.tokenIndexList
                            );
                            mentionMap.set(
                                node.spanId.uuidString,
                                updateMention
                            );
                        }
                    } else {

                        const mention: EntityMention = {
                            uuid: {
                                uuidString: node.spanId.uuidString,
                            },
                            tokens: {
                                tokenIndexList: node.tokenIndexList,
                                tokenizationId: node.tokenizationId,
                            },
                            entityType: spanToTypeMap.get(node.spanId.uuidString),
                        };

                        mentionMap.set(node.spanId.uuidString, mention)
                    }
                }


			}
		});
	});

	return Array.from(mentionMap, ([key,value]) => {
        return value
    });
}

export function returnSituationMentionList(spanToTypeMap: Map<string, string>,
	spanTreeMap: Map<string, SpanTree>,
    situationArgumentMap: Map<string,Map<string,Set<string>>>): SituationMention[]{

    const entityMentionMap = new Map<string,EntityMention>();
    const situationMentionMap = new Map<string,SituationMention>();

    spanTreeMap.forEach((tokenization) => {
        tokenization.nodes.forEach((node) => {
            if(node.kind === "span" && node.mentionModel === "entity"){
                if(entityMentionMap.has(node.spanId.uuidString)){
                    const updateMention = entityMentionMap.get(
                        node.spanId.uuidString
                    );

                    if (updateMention !== undefined) {
                        updateMention?.tokens.tokenIndexList.push(
                            ...node.tokenIndexList
                        );
                        entityMentionMap.set(
                            node.spanId.uuidString,
                            updateMention
                        );
                    }
                } else {

                    const mention: EntityMention = {
                        uuid: {
                            uuidString: node.spanId.uuidString,
                        },
                        tokens: {
                            tokenIndexList: node.tokenIndexList,
                            tokenizationId: node.tokenizationId,
                        },
                        entityType: spanToTypeMap.get(node.spanId.uuidString),
                    };

                    entityMentionMap.set(node.spanId.uuidString, mention)
                }
            }
        })
    })

    spanTreeMap.forEach((tokenization) => {
        tokenization.nodes.forEach((node) => {
            if(node.kind === "span" && node.mentionModel === "situation" && spanToTypeMap.has(node.spanId.uuidString)){
                if(situationMentionMap.has(node.spanId.uuidString)){
                    const updateMention = situationMentionMap.get(
                        node.spanId.uuidString
                    );

                    if (updateMention !== undefined) {
                        if(updateMention.tokens === undefined){
                            updateMention.tokens = {
                                tokenIndexList: [],
                                tokenizationId: node.tokenizationId
                            }
                        }
                        updateMention.tokens?.tokenIndexList.push(
                            ...node.tokenIndexList
                        );
                        situationMentionMap.set(
                            node.spanId.uuidString,
                            updateMention
                        );
                    }
                } else {

                    const argumentList: MentionArgument[] = []

                    const argMentions = situationArgumentMap.get(node.spanId.uuidString)

                    argMentions?.forEach((mentionSet,role) => {
                        mentionSet.forEach((value)=> {

                            if(entityMentionMap.has(value)){
                                argumentList.push({
                                    role: role,
                                    tokens: entityMentionMap.get(value)?.tokens
                                })
                            } else {
                                argumentList.push({
                                    role: role,
                                    situationMentionId: {
                                        uuidString: value
                                    }
                                })
                            }
                        })
                    })

                    const mention: SituationMention = {
                        uuid: {
                            uuidString: node.spanId.uuidString,
                        },
                        tokens: {
                            tokenIndexList: node.tokenIndexList,
                            tokenizationId: node.tokenizationId,
                        },
                        argumentList : argumentList,
                        situationType: spanToTypeMap.get(node.spanId.uuidString),
                    };

                    situationMentionMap.set(node.spanId.uuidString, mention)
                }
            }
        })
    })
    
    return Array.from(situationMentionMap, ([key,value]) => {
        return value
    });
}